// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 26px !important;
  --border-color: var(--color-black);
  --border-radius: 5px;
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-input {
  --border: none !important;
  color: #8e8e8e;
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.privacy-btn {
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
  padding: 0px 5px;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}

ion-checkbox {
  margin-left: 0px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: #8e8e8e;
  font-family: AppFont, sans-serif;
}
.input-age ion-input:first-child {
  border-right: 1px solid var(--color-black);
}
.input-age ion-input:last-child {
  border-left: 1px solid var(--color-black);
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--default-background);
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal ion-item {
  --background: var(--default-background);
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 18px;
  height: 18px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .title-text {
  width: 100%;
  font-family: AppFontMedium, sans-serif;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  color: var(--color-black);
  padding-top: 2px;
  margin-bottom: 15px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-size: 24px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 16px;
  }
}
.wrapper-modal .header-block {
  padding: 10px;
  flex-grow: 1;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 30px 30px 0px;
  }
}
.wrapper-modal .footer-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-modal .footer-section .delete-user {
  width: -moz-fit-content;
  width: fit-content;
  height: 36px;
  padding: 10px 15px;
  border: 1px solid #811b0f;
  border-radius: 26px;
  color: #811b0f;
  text-transform: uppercase;
  margin-bottom: 30px;
  font-family: AppFontMedium;
  font-size: 14px;
  letter-spacing: 0.08em;
  cursor: pointer;
  text-transform: uppercase;
}

.update-user {
  padding: 10px;
  width: 100%;
  border-top: 0.5px solid var(--color-black-alt);
}
.update-user ion-button {
  width: 100%;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.update-btn {
  --background: var(--ion-color-secondary);
  --border-radius: 50px;
  color: var(--color-black);
  width: 100%;
}
.update-btn:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/user-data-modal/user-data-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;AADD;;AAIA;EACC,QAAA;EACA,kBAAA;AADD;;AAGA;EACC,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;AAAD;AAEC;EACC,2BAAA;AAAF;;AAGA;EACC,yBAAA;EACA,cAAA;EACA,gCAAA;AAAD;;AAEA;EACC,kBAAA;EACA,yBAAA;AACD;;AAEA;EACC,eAAA;EACA,6BAAA;AACD;AAAC;EACC,YAAA;EACA,+BAAA;EACA,0BAAA;AAEF;;AACA;EACC,gBAAA;AAED;;AACA;EACC,eAAA;EACA,mBAAA;AAED;;AACA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;AAED;;AACA;EACC,gBAAA;AAED;AADC;EACC,kBAAA;AAGF;;AACA;EACC,gBAAA;AAED;;AACA;EACC,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAED;;AAAA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AAGD;;AAAC;EACC,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;AAGF;AADC;EACC,0CAAA;AAGF;AADC;EACC,yCAAA;AAGF;;AAAA;EACC,yBAAA;EACA,gBAAA;AAGD;;AADA;EACC,YAAA;EACA,mBAAA;AAID;;AAFA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAKD;AAJC;EACC,WAAA;EACA,gBAAA;AAMF;AAJC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAKF;AAJE;EACC,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAMH;;AAFA;EAOC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qCAAA;AADD;ACpIE;EDsHF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAgBA;AACF;AANC;EACC,uCAAA;AAQF;AANC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAQF;AANC;EACC,WAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAQF;AC3KE;ED0JD;IAYE,eAAA;EASD;AACF;AAPC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;AASF;ACxLE;EDyKD;IAQE,eAAA;EAWD;AACF;AATC;EACC,aAAA;EAIA,YAAA;AAQF;ACjME;EDoLD;IAGE,sBAAA;EAcD;AACF;AAXC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAaF;AAZE;EACC,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EAEA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AAaH;;AATA;EACC,aAAA;EACA,WAAA;EACA,8CAAA;AAYD;AAXC;EACC,WAAA;AAaF;;AAVA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAaD;;AAVA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAaD;AC9OE;ED4NF;IAQE,4BAAA;IACA,eAAA;EAcA;AACF;;AAPA;EACC,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;AAUD;AATC;EACC,YAAA;AAWF","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n\tgap: 5px;\n\tmargin-bottom: 8px;\n}\nion-item {\n\t--border-width: 1px !important;\n\tborder: none !important;\n\t--border-radius: 26px !important;\n\t--border-color: var(--color-black);\n\t--border-radius: 5px;\n\tmargin-bottom: 12px;\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n}\nion-input {\n\t--border: none !important;\n\tcolor: #8e8e8e;\n\tfont-family: AppFont, sans-serif;\n}\n.no-line {\n\tborder-bottom: 0px;\n\t--background: transparent;\n}\n\n.privacy {\n\tfont-size: 12px;\n\tcolor: var(--ion-color-black);\n\tion-button {\n\t\tpadding: 0px;\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-transform: capitalize;\n\t}\n}\n.privacy-btn {\n\tmargin-left: 5px;\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\n.stacked {\n\tposition: relative;\n\tz-index: 2;\n\tleft: 20px;\n\ttop: 7px;\n\tpadding: 0px 5px;\n}\n\n.terms {\n\tmargin-left: 0px;\n\tion-checkbox {\n\t\tmargin-right: 10px;\n\t}\n}\n\nion-checkbox {\n\tmargin-left: 0px;\n}\n\n.stacked {\n\tposition: static;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 2;\n}\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n}\n.input-age {\n\tion-input {\n\t\theight: 100%;\n\t\ttext-align: center;\n\t\tcolor: #8e8e8e;\n\t\tfont-family: AppFont, sans-serif;\n\t}\n\tion-input:first-child {\n\t\tborder-right: 1px solid var(--color-black);\n\t}\n\tion-input:last-child {\n\t\tborder-left: 1px solid var(--color-black);\n\t}\n}\nion-footer {\n\t--background: transparent;\n\tbox-shadow: none;\n}\n.loading {\n\theight: 50vh;\n\talign-items: center;\n}\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tion-button {\n\t\twidth: 100%;\n\t\tmargin: 10px 0px;\n\t}\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tp {\n\t\t\tmargin-top: 5px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t}\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\toverflow-x: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tbackground: var(--default-background);\n\tion-item {\n\t\t--background: var(--default-background);\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t}\n\t.title-text {\n\t\twidth: 100%;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 14px;\n\t\tletter-spacing: 0.08em;\n\t\ttext-transform: uppercase;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\tpadding-top: 2px;\n\t\tmargin-bottom: 15px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 24px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tpadding: 10px;\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n\t.header-block {\n\t\tpadding: 10px;\n\t\t@include desktop {\n\t\t\tpadding: 30px 30px 0px;\n\t\t}\n\t\tflex-grow: 1;\n\t}\n\t.footer-section {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t.delete-user {\n\t\t\twidth: fit-content;\n\t\t\theight: 36px;\n\t\t\tpadding: 10px 15px;\n\t\t\tborder: 1px solid #811b0f;\n\t\t\tborder-radius: 26px;\n\t\t\tcolor: #811b0f;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 30px;\n\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0.08em;\n\t\t\tcursor: pointer;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n}\n.update-user {\n\tpadding: 10px;\n\twidth: 100%;\n\tborder-top: 0.5px solid var(--color-black-alt);\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n}\n\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\n\t@include mobile {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 14px;\n\t}\n}\n\n.input-age::part(native) {\n\t// --border-style: none;\n}\n\n.update-btn {\n\t--background: var(--ion-color-secondary);\n\t--border-radius: 50px;\n\tcolor: var(--color-black);\n\twidth: 100%;\n\t&:hover {\n\t\topacity: 0.9;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
